import axios from "axios"
import "./common"

export default {
  getList: params => axios.get(`/indemnities`, { params: params }),
  get: (id, maxi_payload = false)  => axios.get(`/indemnities/${id}`, {params: {maxi_payload}}),
  publish: (id, params) => axios.post(`/indemnities/${id}/publish`, params),
  publishInBatch: params => axios.post(`/indemnities/publish-in-batch` , params),
  independentsInside: params => axios.get(`/indemnities/independents-inside` , {params}),
  checkFees: () => axios.get(`/indemnities/check-fees`),
  updateInvoiceNumber: (id, number) => axios.patch(`/indemnities/${id}/update-invoice-number`, {number}),
  unpublish: (id) => axios.patch(`/indemnities/${id}/unpublish`),
  getBatches: params => axios.get(`/indemnities-batches`, { params: params }),
  getBatchZIP: id => axios.get(`/indemnities-batches/${id}/zip`, {responseType: 'blob'}),
  myCurrentWorkingTime: () => axios.get(`/indemnities/my-current-working-time`)
}
